import React from 'react'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import { getQueryStringValueByParameter } from '../helpers'
import { connect } from 'react-redux'
import { fetchUserByOpportunityId } from '../actions/userActions'
import { loginPageRequest } from '../actions/authenticationActions'
import { updateAccount, updateToken } from '../actions/updateActions'
import { msalAppRS, msalAppMX, tokenRequest } from '../utils/authConfig'
import { receiveConsultantLoginSuccess } from '../actions/authenticationActions'
import { updateForProposalViewFromEmail } from 'application/actions/emailActions'
import * as E from './../components/pages/login/loginElements'
import { Icon } from 'RemServ/icons'
import { Image as RemServImage } from 'RemServ/images'
import globals from 'application/constants/globals'

class Consultant extends React.Component {
  state = {
    isOpportunityIDProvided: false,
    isOpportunityIDValid: true,
    isAuthenticated: false,
    opportunityId: null,
  }

  componentDidMount() {
    this.props.dispatch(loginPageRequest())
    var url = window.location.href.toLowerCase()
    if (url.indexOf('?oppid=') !== -1) {
      let oppId = getQueryStringValueByParameter('oppid', url)
      this.props.dispatch(fetchUserByOpportunityId(oppId))
      this.setState({
        isOpportunityIDProvided: true,
        opportunityId: oppId,
      })
    }

    if (url.indexOf('&viewproposal=true') !== -1) {
      this.props.dispatch(updateForProposalViewFromEmail())
    }
  }

  handleSignIn = () => {

    let msal = globals.isBrandMX ? msalAppMX : msalAppRS

    if (this.props.user.email !== null) {
      this.setState({
        isOpportunityIDValid: true,
      })
      this.props.onSignIn().then(() => {
        msal
          .acquireTokenSilent(tokenRequest)
          .then((response) => {
            this.props.dispatch(updateToken(response.accessToken))
            if (this.props.account) {
              this.props.dispatch(updateAccount(this.props.account))
              this.props.dispatch(
                receiveConsultantLoginSuccess(this.state.opportunityId)
              )
              this.props.history.push(
                this.props.user.isAtSettlement
                  ? '/consultant/settlements'
                  : '/consultant/home'
              )
            } else {
              if (this.props.error) {
                this.props.updateError(this.props.error)
              } else {
                this.props.updateError({
                  errorMessage: 'Sign-in failed. Please try again.',
                })
              }
            }
          })
          .catch((error) => {
          })
      })
    } else {
      this.setState({
        isOpportunityIDValid: false,
      })
    }
  }

  handleSignOut = () => {
    this.props.onSignOut().then(() => {
      if (!this.props.account) {
        this.props.updateAccount(null)
        this.props.dispatch(updateAccount(null))
      } else {
        if (this.props.error) {
          this.props.updateError(this.props.error)
        } else {
          this.props.updateError({
            errorMessage: 'Sign-out failed. Please try again.',
          })
        }
      }
    })
  }
 

  render() {

    let MaxxiaHeader = ({}) => (
      <div>
        <E.MaxxiaLogoContainer>
          <E.MaxxiaLogo imageName="LogoWhite" />
        </E.MaxxiaLogoContainer>
  
        <E.MaxxiaBGLogin>
          <div className="bg-login__overlay"></div>
          <div className="bg-login__box"></div>
        </E.MaxxiaBGLogin>
      </div>
    )

    const CommonContainer = ({email, oppProvided, oppValid, handleSignIn}) => (
      <E.CommonContainer className="shadow-sm">
        {oppProvided && (
          <>
            <div className="text-center mt-3 mb-3">
              <h2 className="text-dark">
                Welcome to the Digital Estimate Portal
              </h2>
              <br />
              <div>
                To access your customer’s estimate(s), please login using your
                McMillan Shakespeare credentials below.
              </div>
            </div>
            <div className="text-center mt-3 mb-3">
              <div>
                {email && (
                  <img
                    className="mt-3 clickable btn-consultant"
                    onClick={handleSignIn}
                    src="/images/icon-btn-consultant.png"
                    alt=""
                  />
                )}
                {!email && (
                  <img
                    className="mt-3 clickable btn-consultant readonly"
                    src="/images/icon-btn-consultant.png"
                    alt=""
                  />
                )}
              </div>
            </div>
          </>
        )}

        {!oppValid && (
          <div className="text-center mt-3 mb-3 text-danger">
            Please enter a valid opportunity ID
          </div>
        )}

        {!oppProvided && (
          <div className="text-center mt-3 mb-3 text-danger">
            Opportunity ID is not provided
          </div>
        )}
      </E.CommonContainer>
    )

    return (
      <div id="page" className="app">
        {global.config.brand === 'Maxxia' && (
          <>
            <MaxxiaHeader />
            <CommonContainer 
              email={this.props.user.email} 
              oppValid={this.state.isOpportunityIDValid}
              oppProvided={this.state.isOpportunityIDProvided}
              handleSignIn={this.handleSignIn} 
            />
          </>
        )}
        {global.config.brand === 'RemServ' && (
          <E.RemServContainer>
            <RemServImage imageName="BannerImageRemserv" />
            <E.RemServImageContainer>             
              <Icon iconType="remservWhiteLogo" size={2} />
              <CommonContainer 
                email={this.props.user.email} 
                oppValid={this.state.isOpportunityIDValid}
                oppProvided={this.state.isOpportunityIDProvided} 
                handleSignIn={this.handleSignIn} 
              />
            </E.RemServImageContainer>
          </E.RemServContainer>
        )}
      </div>
    )
  }
}

Consultant.propTypes = {
  account: PropTypes.object,
  error: PropTypes.string,
  onSignIn: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    auth: state.auth,
  }
}

export default connect(mapStateToProps)(Consultant)

